import * as React from 'react';
import {connect, Dispatch} from 'react-redux';
import {translate} from "react-i18next";

import NavLink from './NavLink';
import {compose} from 'redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import HATEOASClient from '../../services/HATEOASClient';
import {MenuDto, UserDto} from '../../services/Client';
import {IUserSettings} from '../../data/IUserSettings';
import {selectBaseLinks, selectClient, selectOpenApprovalsCount, selectUserInfo, selectUserSettings} from '../../redux/selectors';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {IReduxState} from '../../redux/IReduxState';
import GeneralActions from 'src/redux/actions/GeneralActions';

interface IMapStateToProps {
    openApprovalsCount: number | undefined;
    userSettings: IUserSettings;
    baseLinks: MenuDto | undefined;
    client: HATEOASClient;
    userInfo: UserDto | undefined;
}
interface IMapDispatchToProps {
    SetKumaManagerRolePermission: (isShow: boolean) => void;
}

interface MainTiles extends RouteComponentProps<any>, IMapStateToProps, ITranslatedComponent,IMapDispatchToProps {
    isFromTop?:boolean;
 }

class MainTiles extends React.Component<MainTiles> {
    constructor(props: MainTiles) {
        super(props);
    }

    render() {
        const {t, baseLinks, client, history, openApprovalsCount,isFromTop} = this.props;

        const hasAdminArea = baseLinks && client.GET_adminArea(baseLinks).canExecute();
        const hasSupportRole = baseLinks && client.GET_supportArea(baseLinks).canExecute();
        const hasKumaRole = baseLinks && client.GET_kumaExtraLinks(baseLinks).canExecute();
        const hasManagementRole = baseLinks && client.GET_kumaManagement(baseLinks).canExecute();
        const isPSL = baseLinks && client.GET_pslExtraLinks(baseLinks).canExecute();
        const isOptionBasic = baseLinks && client.GET_optionBasicExtraLinks(baseLinks).canExecute();
        const isDerivate = baseLinks && client.GET_modeltypeBasicExtraLinks(baseLinks).canExecute();
        // if(!isPSL && !isOptionBasic && !isDerivate) {
        //     this.props.SetKumaManagerRolePermission(false);
        //     history.push('/kuma/managementview');
        // } else {
        //     this.props.SetKumaManagerRolePermission(true);
        // }
        return (
            <>
                <NavLink
                    label={t("START_VIEW:DERIVATES")}
                    data="derivate"
                    imageSource='./images/Tiles/derivates.png'
                    contextMenuUrl='/modeltypebasic'
                    onClick={() => history.push("/modeltypebasic")}
                    isFromTop={isFromTop || false}
                />

                <NavLink
                    data="option-basic"
                    label={t("START_VIEW:BASE_OPTIONS")}
                    imageSource='./images/Tiles/base_options.png'
                    contextMenuUrl='/optionbasic'
                    onClick={() => history.push("/optionbasic")}
                    isFromTop={isFromTop || false}
                />

                <NavLink
                    data="psl"
                    label={t("START_VIEW:OPEN_PSL")}
                    imageSource='./images/Tiles/psl.png'
                    contextMenuUrl='/options'
                    onClick={() => history.push("/options")}
                    isFromTop={isFromTop || false}
                />

                {hasKumaRole   &&
                    <NavLink
                        label={t("START_VIEW:KUMA")}
                        data="kuma"
                        imageSource='./images/Tiles/kuma.png'
                        contextMenuUrl='/kuma'
                        onClick={() => history.push("/kuma")}
                        isFromTop={isFromTop || false}
                    />
                }
                 {(!hasKumaRole && hasManagementRole)  &&
                    <NavLink
                        label={t("START_VIEW:KUMA")}
                        imageSource='./images/Tiles/kuma.png'
                        contextMenuUrl='/kuma/managementview'
                        onClick={() => history.push("/kuma/managementview")}
                        isFromTop={isFromTop || false}
                    />
                }

                {openApprovalsCount !== undefined &&
                    <div className="approvals-tile-notification-container">
                        <NavLink
                            label={t("START_VIEW:APPROVALS")}
                            imageSource='./images/Tiles/approvals.png'
                            contextMenuUrl='/approval'
                            onClick={() => history.push("/approval")}
                            isFromTop={isFromTop || false}
                        />
                        <span className="approvals-tile-notification-icon">{openApprovalsCount}</span>
                    </div>
                }

                {/* <NavLink
                    label={t("START_VIEW:TECHNICAL_DATA")}
                    imageSource='./images/Tiles/technical_data.jpg'
                    onClick={() => history.push("/technicaldata")}
                />

                {hasSupportRole &&
                    <NavLink
                        label={t("START_VIEW:SUPPORT")}
                        imageSource='./images/Tiles/support.jpg'
                        onClick={() => history.push("/support")}
                    />
                } */}
                {hasAdminArea &&
                    <NavLink
                        label={t("SIDEBAR:ADMINISTRATION")}
                        imageSource='./images/Tiles/administration.png'
                        contextMenuUrl='/admin'
                        onClick={() => history.push("/admin")}
                        isFromTop={isFromTop || false}
                    />
                }

            </>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    openApprovalsCount: selectOpenApprovalsCount(state),
    userSettings: selectUserSettings(state),
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
    userInfo: selectUserInfo(state),
});
const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: RouteComponentProps): IMapDispatchToProps => ({
    SetKumaManagerRolePermission: (isShow: boolean) => dispatch(GeneralActions.SetKumaManagerRolePermission(isShow))
});
export default compose(
    withRouter,
    translate(["START_VIEW", "SIDEBAR"]),
    connect<IMapStateToProps>(mapStateToProps,mapDispatchToProps),
)(MainTiles);



// WEBPACK FOOTER //
// ./src/components/NavLink/MainTiles.tsx